

// Import ----------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";
import PageLayout from "~/layouts/Hero.vue";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component imports -------------------------------------------------------

    components: {
        PageLayout
    },

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"]

    // -------------------------------------------------------------------------
});
